"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _BottomNavigation = _interopRequireDefault(require("@material-ui/core/BottomNavigation"));
var _styles = require("@material-ui/core/styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      backgroundColor: theme.palette.primary.main,
      boxShadow: '0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12)'
    }
  };
});
function SttBottomNavigation(props) {
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_BottomNavigation["default"], _extends({
    className: classes.root,
    showLabels: true
  }, props));
}
var _default = SttBottomNavigation;
exports["default"] = _default;